import { ItemId, Video } from '../../../types/items';
import { ItemList, ListParams } from '../../../types/main';
import { action, withoutPayload, withPayload } from '../../../utility/redux';

export const initVideoRequest = action(
  'INIT_VIDEO_REQUEST',
  withoutPayload,
);
export const initVideoSuccess = action(
  'INIT_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const initVideoFail = action(
  'INIT_VIDEO_FAIL',
  withoutPayload,
);

export const createVideoRequest = action(
  'CREATE_VIDEO_REQUEST',
  withPayload<Video>(),
);
export const createVideoSuccess = action(
  'CREATE_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const createVideoFail = action('CREATE_VIDEO_FAIL', withoutPayload);

export const getVideoListRequest = action(
  'GET_VIDEO_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getVideoListSuccess = action(
  'GET_VIDEO_LIST_SUCCESS',
  withPayload<ItemList<Video>>(),
);
export const getVideoListFail = action(
  'GET_VIDEO_LIST_FAIL',
  withoutPayload,
);

export const setVideoListDirty = action(
  'SET_VIDEO_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getVideoRequest = action(
  'GET_VIDEO_REQUEST',
  withPayload<ItemId>(),
);
export const getVideoSuccess = action(
  'GET_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const getVideoFail = action('GET_VIDEO_FAIL', withoutPayload);

export const resetCurrentVideo = action('RESET_CURRENT_VIDEO', withoutPayload);

export const saveVideoRequest = action(
  'SAVE_VIDEO_REQUEST',
  withPayload<Video>(),
);
export const saveVideoSuccess = action(
  'SAVE_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const saveVideoFail = action('SAVE_sVIDEO_FAIL', withoutPayload);

export const deleteVideoRequest = action(
  'DELETE_VIDEO_REQUEST',
  withPayload<ItemId>(),
);
export const deleteVideoSuccess = action(
  'DELETE_VIDEO_SUCCESS',
  withoutPayload,
);
export const deleteVideoFail = action('DELETE_VIDEO_FAIL', withoutPayload);

export const clearVideoList = action('CLEAR_VIDEO_LIST', withoutPayload);
